import { render } from "./FinanceReport.vue?vue&type=template&id=3607c8c4"
import script from "./FinanceReport.vue?vue&type=script&lang=js"
export * from "./FinanceReport.vue?vue&type=script&lang=js"

import exportComponent from "/builds/shapkin/crm-mentoring.exportedu.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__